module.exports = __webpack_public_path__ + "img/total_certificate.fa5a63df.svg";